import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { UpdateGoalConfigInput } from '@pms/shared';
import { goalsService } from '@/services/goals.service';
import { getErrorMessage } from '@/lib/errors';

const KEY = ['goals', 'config', 'settings'] as const;

/** One concern: read + save the goal automation settings. */
export function useGoalConfig() {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: KEY,
    queryFn: () => goalsService.getConfig(),
  });

  const mutation = useMutation({
    mutationFn: (patch: UpdateGoalConfigInput) => goalsService.updateConfig(patch),
    onSuccess: () => {
      toast.success('Automation settings saved');
      void queryClient.invalidateQueries({ queryKey: KEY });
    },
    onError: (e) => toast.error(getErrorMessage(e)),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => void query.refetch(),
    save: mutation.mutate,
    saving: mutation.isPending,
  };
}

export const GOAL_CONFIG_KEY = KEY;
